fx.ns("desktop.common.zoom", class PreviewBox extends fx.Component {
    
	constructor(model, board)
	{
		super();

		this._board = board;

		this._model = model;
		this.book = model.creation

		this.listenUpdates( model.zoom, true);
	}

	get model()
    {
        return this._model;
    }

    set model(val)
    {
        this._model = val;
    }

	get book()
	{
		return this.data;
	}

	set book(val)
	{
		this.data = val;

		//if (this.visible)
		//	this._buildStage();
	}

	get board()
	{
		return this._board;
	}

	set board(val)
	{
		this._board = val;

		//if (this.visible)
		//	this._buildStage();
	}

	create()
	{
		super.create();

		this.zoomSurface = new fx.components.Box("surface");

		this.addChild( this.zoomSurface, {width:"100%", height:"100%", top : 0, left : 0} );	
	}

	show(){
		if (this.visible)
			return;

		super.show();
		
		//this._buildStage();

		this.on("mousedown", this._onMouseDown, this.zoomSurface);
        this.on("mousemove", this._onMouseMove, window);
        this.on("mouseup", this._onMouseUp, window);
		this.on("blur", this._onMouseUp, window);
		
		this.on('mousewheel', this._onMouseWheel, window );
	}

	hide()
	{
		if (!this.visible)
			return;

		super.hide();

		// remove stage
		if (this._area)
		{
			this.removeChild( this._area, true );
			this._area = null;
		}

		this.off("mousedown", this._onMouseDown, this.zoomSurface);
        this.off("mousemove", this._onMouseMove, window);
        this.off("mouseup", this._onMouseUp, window);
		this.off("blur", this._onMouseUp, window);
		
		this.off('mousewheel', this._onMouseWheel, window );
	}
	
	
	updateStage()
	{
		if (!this.board || !this.book || this.model.zoom.value <= 100)
			return;

		if (this._area)
		{
			this.removeChild( this._area, true );
			this._area = null;
		}
		
		this._updateHeight();
		
		//--- add Page or Cover
		this.page = this.board.currentArea.data;

		if (!this.page) return;

		if (this.page.typeid == 6) // cover
		{
			this._area = new shared.stage.Cover(this.page, this.model, this);
			this._area.hideLabels = true;
			this.addChild(this._area, {width : this.book.coverWidth, height : this.book.coverHeight});
			this._area.load();
		}
		else
		{
			this._area = new shared.stage.Page(this.page, this.model, this);
			this.addChild(this._area, {width : this.book.pageWidth * 2, height : this.book.pageHeight});
			this._area.load();
		}

		this.board.currentView.centerCurrentArea();
		this._zoomSurfaceOriginalPosition = fx.graphics.getTranslate( this.board.currentArea, false);
		
        let ratio = this._area.height() / this._area.width(),
        screenWidth = this.realWidth * 0.80,
        screenHeight = this.realHeight * 0.80;

        if (screenWidth * ratio < screenHeight)
            this._area.scale = screenWidth / this._area.width();
        else
            this._area.scale = screenHeight / this._area.height();
        
		this._areaX = (this.realWidth/this._area.scale - this._area.realWidth) / 2;
		this._areaY = (this.realHeight/this._area.scale - this._area.realHeight) / 2;
		
		this._area.css({ 
			//"transform" : "scale(" + this._area.scale + ") translate(" + this._areaX + "px, " + this._areaY + "px)"
			"transform" : "scale(" + this._area.scale + ") translate(" +this._areaX + "px, " + this._areaY + "px)",
		}); 

		this._area.show();

		this.updatePositions(true);
	}

	onDataUpdated(action)
	{
		super.onDataUpdated(action);

		if (action.impacts("value") && this.model.zoom.value > 100)
			this.updatePositions(true);

		if (action.impacts("surfaceWidth"))
			this.zoomSurface.viewport({ width : this.model.zoom.surfaceWidth,
										height : this.model.zoom.surfaceHeight,
										left : this.model.zoom.surfaceX,
										top : this.model.zoom.surfaceY});
		else
		if (action.impacts("surfaceX"))
			this.zoomSurface.move(this.model.zoom.surfaceX,this.model.zoom.surfaceY);
	}
	
	updatePositions(initial)
	{
		if (this._area)
		{
			this.newSize = { width : (1/this.model.zoom.realValue) * this.realWidth,
							height : (1/this.model.zoom.realValue) * this.realHeight};
			
			let xPos, yPos, 
				surfaceWidth = this.newSize.width, 
				surfaceHeight = this.newSize.height;

			if (initial) // center zoomSurface
			{
				xPos = this.realWidth * ( 1 - 1 /this.model.zoom.realValue) / 2;
				yPos = this.realHeight * ( 1 - 1 /this.model.zoom.realValue) / 2;
			}
			else
			{
				xPos = (this.zoomSurface.realPosition.left + (this.zoomSurface.realWidth - this.newSize.width) / 2);
				yPos = (this.zoomSurface.realPosition.top + (this.zoomSurface.realHeight - this.newSize.height) / 2);

				if (xPos < 0) xPos = 0;
				if (yPos < 0) yPos = 0;

				if (xPos + this.newSize.width > this.realWidth) 
					xPos = this.realWidth - this.newSize.width;

				if (yPos + this.newSize.height > this.realHeight) 
					yPos = this.realHeight - this.newSize.height;
			}
			
			this.ratioX = this.newSize.width /  (this.board.currentArea.realWidth * this.board.currentArea.scale);
			this.ratioY = this.newSize.height / (this.board.currentArea.realHeight * this.board.currentArea.scale);
			
			let x = this._zoomSurfaceOriginalPosition.x/ this.board.currentArea.scale/this.model.zoom.realValue - (xPos/ this.ratioX / this.board.currentArea.scale/this.model.zoom.realValue);
			let y = this._zoomSurfaceOriginalPosition.y/ this.board.currentArea.scale/this.model.zoom.realValue - (yPos/ this.ratioY / this.board.currentArea.scale/this.model.zoom.realValue);
			
			this.model.zoom.update("update", { x : x, y : y, scale : this.model.zoom.realValue, animate : true, initial : initial, surfaceX : xPos, surfaceY : yPos, surfaceWidth : surfaceWidth, surfaceHeight : surfaceHeight});			
		}
	}

	_updateHeight()
	{
		if (this.board && this.board.currentArea)
			this.height( (this.board.currentArea.realHeight * 1.5) * this.realWidth / (this.board.currentArea.realWidth * 1.5) );
	}

	onDisplayUpdated()
	{
		super.onDisplayUpdated();

		this._updateHeight();
	}


	_onMouseDown(event)
	{
		if (!this.board) return;

		this._moveData = {};
		this._moveData.offset = {   
			offsetX : event.pageX - this.zoomSurface.x,
			offsetY : event.pageY - this.zoomSurface.y
		};

		this.board.currentElement = null;
		//this.board.currentOverElement = null;
	}

    _onMouseMove(event)
	{
		if (this._moveData)
		{
			let yPos = event.pageY - this._moveData.offset.offsetY;
			let xPos = event.pageX - this._moveData.offset.offsetX;

			if (xPos < 0)
				xPos = 0;

			if (xPos + this.zoomSurface.realWidth + 4 > this.realWidth)
				xPos = this.realWidth - this.zoomSurface.realWidth - 4;

			if (yPos < 0)
				yPos = 0;

			if (yPos + this.zoomSurface.realHeight + 4> this.realHeight)
				yPos = this.realHeight - this.zoomSurface.realHeight - 4;
			
			let x = this._zoomSurfaceOriginalPosition.x/ this.board.currentArea.scale/this.model.zoom.realValue - (xPos/ this.ratioX / this.board.currentArea.scale/this.model.zoom.realValue);
			let y = this._zoomSurfaceOriginalPosition.y/ this.board.currentArea.scale/this.model.zoom.realValue - (yPos/ this.ratioY / this.board.currentArea.scale/this.model.zoom.realValue);

			this.model.zoom.update({ x : x, y : y, scale : this.model.zoom.realValue, animate : false, initial : false, surfaceX : xPos, surfaceY : yPos});  
		}
	}
	
	_onMouseUp(e)
	{
		this._moveData = null;
	}

	_onMouseWheel(e)
	{
		if (!fx.dom.parent(e.target, this))
			return;
			
        if (!e.deltaY) return;

		if (e.deltaY < 0)
			this.model.zoom.in();
		else
			this.model.zoom.out();
	}
	
});